export const B2B_DOMAIN = 'louis.biz';
